import { reportRaptorMetrics } from '@/src/common/SLRaptor';
import { cloneDeep } from 'lodash';

const reportFilterInitSelectResult = (value, params = {}) => {
  const tags = { ...params, result: value ? 'success' : 'fail' };
  reportRaptorMetrics({ FilterBarInitSelected: value }, tags);
};

export const initFilterDataSelectedStatusByOptions = (originalFilterData, options) => {
  try {
    if (!originalFilterData?.json_data) throw new Error('filter init select failed');
    const filterData = cloneDeep(originalFilterData);
    const { json_data: data } = filterData || {};
    const { filterOptions = [], sortOptions: { sortCode = '', sortTypeList = [] } = {} } = options || {};
    const { filterOptions: filterOptionsData, sortOptions: sortOptionsData } = data;
    const isFilterOptionSelected = (filterOptionValue, options) => {
      delete filterOptionValue.isSelected;
      const { jsonValue } = filterOptionValue;
      const isSelected = options.some((i) => i.filterOptionValues.some((v) => v.jsonValue === jsonValue));
      if (isSelected) {
        filterOptionValue.isSelected = true;
      }
    };
    filterOptionsData.forEach((filterOptionData) => {
      const { filterOptionValues = [], groupFilterOptions } = filterOptionData;
      filterOptionValues.forEach((value) => isFilterOptionSelected(value, filterOptions));
      if (groupFilterOptions?.length) {
        groupFilterOptions.forEach((groupFilterOption) => {
          const { groupFilterOptionValues = [] } = groupFilterOption;
          groupFilterOptionValues.forEach((value) => isFilterOptionSelected(value, filterOptions));
        });
      }
    });
    sortOptionsData.sortOptionValues.forEach((item) => {
      delete item.isSelected;
      const isSelected = item.sortCode === sortCode && item.sortTypeList.join(',') === sortTypeList.join(',');
      if (isSelected) {
        item.isSelected = true;
      }
    });
    reportFilterInitSelectResult(1);
    return filterData;
  } catch (e) {
    reportFilterInitSelectResult(0);
    return originalFilterData;
  }
};
